import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    systemLogo: null,
};
var systemConfigSlice = createSlice({
    name: "systemConfig",
    initialState: initialState,
    reducers: {
        setSystemLogo: function (state, data) {
            state.systemLogo = data.payload;
        },
    },
});
export var setSystemLogo = systemConfigSlice.actions.setSystemLogo;
export default systemConfigSlice.reducer;
